import { render } from "./App.vue?vue&type=template&id=2f1d2b73"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2f1d2b73&lang=css"
script.render = render

export default script